module.exports = __webpack_public_path__ + "media/images/Logo_Levante-Crypto-196f8cbacfb0ecf6b39bfeb06b7efb86.png";